import {
  LeaderboardViewDTONameSearchModeEnum,
  TableViewParamsDTO,
} from 'generated/leaderboard-client';

import { NameSearchMode } from '@neptune/shared/search-domain';

import { isNotUndefined } from 'common/tsHelpers';

import { ColumnModelConverter } from './column/column-model-converters';
import { GroupOptionsModelConverter } from './group-options/group-options-model-converter';
import { STANDARD_SORTING_OPTIONS } from './sort-options/sort-options-default';
import { SortOptionsModelConverter } from './sort-options/sort-options-model-converter';
import { RunsLineage, TableViewParams } from './table-view-params-model';

export class TableViewParamsConverter {
  static fromApiToDomain(tableViewParams: TableViewParamsDTO): TableViewParams {
    const groupOptions = tableViewParams.groupOptions
      ? GroupOptionsModelConverter.fromApiToDomain(tableViewParams.groupOptions)
      : null;
    return {
      query: tableViewParams.query,
      experimentsOnly: tableViewParams.experimentsOnly,
      sortOptions:
        SortOptionsModelConverter.fromApiToLegacy(tableViewParams.sortOptions) ||
        STANDARD_SORTING_OPTIONS,
      columnList: tableViewParams.columnList.columns.map(
        ColumnModelConverter.columnFromApiToDomain,
      ),
      runsLineage: tableViewParams.runsLineage ? RunsLineage.FULL : RunsLineage.NONE,
      nameSearchMode:
        tableViewParams.nameSearchMode === LeaderboardViewDTONameSearchModeEnum.Substring
          ? NameSearchMode.SUBSTRING
          : NameSearchMode.REGEX,
      nameSearchQuery: tableViewParams.nameSearchQuery,
      ...(groupOptions ? { groupOptions } : {}),
    };
  }

  static fromDomainToApi(tableViewParams: TableViewParams): TableViewParamsDTO {
    return {
      experimentsOnly: tableViewParams.experimentsOnly,
      sortOptions: SortOptionsModelConverter.fromLegacyToApi(tableViewParams.sortOptions),
      columnList: {
        columns: tableViewParams.columnList
          .map(ColumnModelConverter.columnFromDomainToApi)
          .filter(isNotUndefined),
      },
      runsLineage: tableViewParams.runsLineage === RunsLineage.FULL,
      groupOptions: tableViewParams.groupOptions
        ? GroupOptionsModelConverter.fromDomainToApi(tableViewParams.groupOptions)
        : undefined,
      query: tableViewParams.query,
      nameSearchQuery: tableViewParams.nameSearchQuery,
      nameSearchMode:
        tableViewParams.nameSearchMode === NameSearchMode.REGEX
          ? LeaderboardViewDTONameSearchModeEnum.Regexp
          : LeaderboardViewDTONameSearchModeEnum.Substring,
    };
  }
}
